import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "../utils";

import "./styles.scss";

export const CharacterCounter = ({ characterLimit, className, length }) => {
  const getCharacterCounterClassName = () => {
    if (length >= characterLimit - 10 && length <= characterLimit) {
      return "CharacterCounter-warning";
    } else if (length > characterLimit) {
      return "CharacterCounter-error";
    }
  };

  return (
    <p
      className={createClassNameString([
        "CharacterCounter-text",
        getCharacterCounterClassName(),
        className,
      ])}
      data-public
    >
      {length ?? 0}/{characterLimit}
    </p>
  );
};

CharacterCounter.propTypes = {
  characterLimit: PropTypes.number,
  className: PropTypes.string,
  length: PropTypes.number,
};
